export const testViewWithPatientProfile = 'Pathologist/PatientProfile';
export const testViewPathologistPath = 'Pathologist';
export const testViewBasePath = 'Test/';
export const testViewWithPatientSearch = 'dashboard/patient_dashboard_tests';